import Accordion from "react-bootstrap/Accordion";
import { CustomAccordionItem } from "types/accordion/CustomAccordionItemType";
import AccordionButton from "react-bootstrap/AccordionButton";
interface CustomAccordionProps {
  itens: CustomAccordionItem[];
  /**Key do item que deverá ser aberto por padrão */
  keyItemAtivoPorPadrao?: string;
  permitirVariosItensAtivos?: boolean;
  alinharBotoesNaDireita?: boolean;
}

export const CustomAccordion: React.FC<CustomAccordionProps> = (props) => {
  const renderAccordionItems = () => {
    const accordionItems = props.itens;

    return accordionItems.map((item: CustomAccordionItem) => {
      return (
        <Accordion.Item className="accordion-item" eventKey={item.key} key={item.key}>
          <AccordionButton
            className={`header-accordion-gc ${item.botoes && item.botoes.length > 0 ? "botao-accordion" : ""}`}
          >
            <div className={`label-accordion ${props.alinharBotoesNaDireita ? "alinhar-botoes-direita" : ""}`}>
              {item.titulo}
              <div className="botoes-accordions">{item.botoes && item.botoes.map((botao) => botao)}</div>
            </div>
          </AccordionButton>
          <Accordion.Body>{item.conteudo}</Accordion.Body>
        </Accordion.Item>
      );
    });
  };

  return (
    <Accordion alwaysOpen={props.permitirVariosItensAtivos} defaultActiveKey={props.keyItemAtivoPorPadrao}>
      {renderAccordionItems()}
    </Accordion>
  );
};

export default CustomAccordion;
